export default "__VITE_PUBLIC_ASSET__a3950bfe__"